import { useState } from "react";
import { DISCLOSURES_URL } from "../../routes";
import { AccordionSection } from "../Accordion";
import { FooterMenuItem } from "./GoodfillFooter";
import "./GoodFillFooter.scss";

const PRIVACY_POLICY_LINK = import.meta.env.VITE_PRIVACY_POLICY_LINK;
const TERMS_AND_CONDITIONS_LINK = import.meta.env.VITE_INTERACTIVE_BROKERS_TERMS_LINK;

export const LegalAccordion = () => {
  const [isLegalAccordionOpen, setLegalAccordionOpen] = useState(false);
  return (
    <AccordionSection
      title={"Legal"}
      isOpen={isLegalAccordionOpen}
      setIsOpen={setLegalAccordionOpen}
      className="GoodFillFooter_accordion"
    >
      <ul>
        <FooterMenuItem title="Privacy Policy" target="_blank" href={PRIVACY_POLICY_LINK}>
          Privacy Policy
        </FooterMenuItem>
        <FooterMenuItem title="Terms &amp; Conditions" target="_blank" href={TERMS_AND_CONDITIONS_LINK}>
          Terms &#038; Conditions
        </FooterMenuItem>
        <FooterMenuItem title="Disclosures" href={DISCLOSURES_URL}>
          Disclosures
        </FooterMenuItem>
      </ul>
    </AccordionSection>
  );
};
